export default __webpack_public_path__ + "static/media/microsoft.73543511.svg";